export const mapArguments = ({
  context,
  name,
  nameMap,
  parameterMap,
  parameters,
} = {}) => {

  const mappedName = nameMap?.[name] || name;
  const mappedParams = {};

  if (typeof parameters !== 'object' && typeof context !== 'object') {

    return {
      mappedName,
      mappedParams,
    };
  }

  const mergedParams = {
    ...((typeof context === 'object' && context) || {}),
    ...((typeof parameters === 'object' && parameters) || {}),
  };

  for (const [paramName, paramValue] of Object.entries(mergedParams)) {

    if (!paramName) {
      continue;
    }

    mappedParams[parameterMap?.[paramName] || paramName] = paramValue;
  }

  return {
    mappedName,
    mappedParams,
  };
};